// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".zoomImage_LePny{height:100%;width:100%}.zoomImage_LePny.allowZoom_qvbJR{cursor:zoom-in}.zoomImage_LePny.zooming_79jiH{cursor:unset}.mainImage_PA61y{width:100%;height:100%;-o-object-fit:contain;object-fit:contain}.lightboxImage_VxmvU{height:auto;max-height:100%}", ""]);
// Exports
exports.locals = {
	"zoomImage": "zoomImage_LePny",
	"allowZoom": "allowZoom_qvbJR",
	"zooming": "zooming_79jiH",
	"mainImage": "mainImage_PA61y",
	"lightboxImage": "lightboxImage_VxmvU"
};
module.exports = exports;
